<template>
 <span>
     <table v-if="pode_alterar">
  <tr>
   <td>
 <datepicker2 v-model="data"  placeholder="Data Início" ></datepicker2>
   </td>
   <td>

                   <input  :id="id_hora" style="width: 90px"
                           type="text" placeholder="Hora" v-model="hora" maxlength="5" 
                            class="md-input pull-left"  >                           

   </td>
  </tr>
     </table>
   

                 <!--
                 <md-input style="width: 90px" type="text" placeholder="Hora" v-model="hora" maxlength="5" :changed="change_hora" ></md-input>
                 -->

 </span>
</template>

<script>

import datepicker2 from "./datepicker2";
import ptBR from "./vuejs-datepicker/src/locale/translations/pt-BR";

import Util from "../../library/Util";
import Mask from "../../library/Mask";

export default {
    components: {
        datepicker2
    },
    props: ['value', 'changed', 'id_hora', 'id_data'],
    model: {
            prop: 'value',
            event: 'selected'
    },
    watch: {

        value (val ) {
            
            if (!this.pode_alterar)
                      return;

            //console.log("Data?? " + this.value );
           //this.data = this.value;
            //this.hora = this.getHourFromDate(this.data);
        },
        hora(val){
               
               if (!this.pode_alterar)
                      return;
            

                if (this.hora != null && this.hora.toString().length == 2 ){
                      this.hora = this.hora +":";
                }

               // if (this.hora != null && this.hora.toString().length == 5 ){
                        //     this.setDataAlterada();
              //  } 
        },
        data(val){

                          //   this.setDataAlterada();
        }


        
    },
   data() {
                return {
                    data: null,
                    hora: "",
                    language_date: ptBR,
                    obj_mask: Mask,
                    pode_alterar: false,

                }
    },
    mounted(){
        this.pode_alterar = false;

        if ( this.value && this.value.trim() != ""){
              var ar = this.value.split(' ');
              console.log("DaepickerHour2 ", ar);
              this.data = ar[0];
              var frags_hora = ar[1].split(':');
              this.hora = frags_hora[0] +":" + frags_hora[1];
        }

        setTimeout( () => {
            this.pode_alterar = true;
        }, 100);
    },
    methods: {
        
        getHourFromDate(date) {
                if (date == null)
                        return "";

                var ar = date.split(' ');     
                if ( ar.length > 1 )
                   return ar[1];   

                return "";   
                //return date.getHours().toString().padStart(2, "0") + ":" + date.getMinutes().toString().padStart(2, "0");
        },
        setDataAlterada(){

            if ( ! this.pode_alterar ){
                return false;
            }

            if ( this.data == undefined ){
                return false;
            }

             if ( this.hora == undefined ){
                return false;
            }

                  if (this.hora != null && this.hora != "" && this.hora.length == 5 && this.data != null ){

                            var ar = this.hora.split(':');

                            var data = new Date( this.data.getFullYear(), this.data.getMonth(), this.data.getDate(),
                                            parseInt( ar[0]),parseInt( ar[1]));

                            this.$emit('selected', data);
                            return false;

                  }

                  if (this.data != null && this.hora == "" ){
                            this.$emit('selected', this.data);
                            return false;

                  }
                  if (this.data == null){
                      this.$emit('selected', this.data);
                      return false;
                  }
                    
        },
    
        datepicker_inputchanged(value){
              console.log("Mudou data"); console.log(value);  
            if ( this.changed != null ){
                this.changed(value);
            }

        },
        change_hora(event){
              console.log("Mudou hora"); console.log(event);  
        },
        GetDataHora(){

            if (this.data ){
                var frag_data = this.data;
                if ( this.data.indexOf(" ") >-1 ){
                    frag_data = this.data.split(' ')[0];
                }
                if ( this.hora && this.hora.trim()!= ""){
                    frag_data += " " + this.hora;
                }

                return frag_data;

            } else {
                 return null;

            }


        }
    }
      
}

</script>